import { ScrollTop } from '../ScrollTop';
import { Copyright } from './copyright/Copyright';
import { FooterNavigation } from './navigation/FooterNavigation';
import { FooterContent } from './content/FooterContent';
import { memo } from 'react';

const FooterComponent = () => {
  return (
    <div className="relative footer bg-light-100 pb-[82px] lg:pb-0" id="kt_footer">
      <div className="footer-content flex justify-evenly lg:gap-8 mt-[30px] flex-col-reverse xl:flex-row">
        {/* TODO: Restore Footer Content */}
        {/* <FooterContent />
        <FooterNavigation /> */}
        {/* <ScrollTop /> */}
      </div>
      <Copyright />
    </div>
  );
};

export const Footer = memo(FooterComponent);
Footer.displayName = 'Footer';
